import React, { useState } from 'react';
import AddBox from '@mui/icons-material/AddBox';
import { Card, IconButton } from '@mui/material';
import { Title } from 'shared/components';
import useStyles from './styles';

const TemplateCard = ({ title, description, src, onClick }) => {
  const classes = useStyles();
  const [isHover, setIsHover] = useState(false);

  const onMouseEnterHandler = () => {
    setIsHover(true);
  };

  const onMouseLeaveHandler = () => {
    setIsHover(false);
  };

  const animation = isHover ? { bottom: 0 } : {};

  return (
    <Card
      className={classes.card}
      onMouseEnter={onMouseEnterHandler}
      onMouseLeave={onMouseLeaveHandler}
    >
      <IconButton
        className={classes.iconAdd}
        color="primary"
        component="span"
        onClick={onClick}
      >
        <AddBox />
      </IconButton>
      <img
        src={src}
        alt={title}
        style={{ width: '100%', aspectRatio: '3 / 1', objectFit: 'cover' }}
      />
      <div className={classes.descriptionBox} style={animation}>
        <Title className={classes.title}>{title}</Title>
        {description}
      </div>
    </Card>
  );
};

export default TemplateCard;
